export const schoolList = {
  qInfo: { qType: "visualization" },
  qHyperCubeDef: {
    qDimensions: [
      {
        qDef: {
          qFieldDefs: ["SchoolName_SchoolProfiles"],
          qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
        },
        qNullSuppression: true
      },
      {
        qDef: {
          /* qFieldDefs: ["peer_group"] */
          qFieldDefs: ["report"]
        },
        qNullSuppression: true
      },
      {
        qDef: {
          qFieldDefs: ["srcschoolid"]
        },
        qNullSuppression: true
      }
    ],
    qMeasures: [],
    qInitialDataFetch: [{ qWidth: 3, qHeight: 1000 }]
  }
};
